import React, { useState, useEffect } from 'react'
import {
  Button,
  Modal,
  notification,
  Input,
  Switch,
  Select,
  Space,
  Upload
} from 'antd'
import axios from 'src/API/config'
import { API } from 'src/API'
import { DollarCircleTwoTone, UploadOutlined } from '@ant-design/icons'

export const CreateUserModal = ({ refresh }) => {
  const [api, contextHolder] = notification.useNotification()

  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [name, setName] = useState('')
  const [firstName, setFirstName] = useState('')
  const [phone, setPhone] = useState('')
  const [vat, setVat] = useState('')

  const [isModalOpen, setIsModalOpen] = useState(false)
  const showModal = () => {
    setIsModalOpen(true)
  }
  const handleOk = async () => {
    try {
      const data = {
        email,
        password,
        password_confirmation: confirmPassword,
        name,
        first_name: firstName,
        phone,
        vat
      }

      await axios.post(`${API.COMMON.usersEndpoint}`, data)

      await api.success({
        message: 'New user',
        description: 'Success',
        placement: 'topRight'
      })
      setIsModalOpen(false)
    } catch (e) {
      let message = <></>

      const errorData = e?.response?.data

      if (errorData?.message) {
        message = errorData?.message
      }

      Object.keys(errorData?.errors).map((error) => {
        errorData?.errors?.[`${error}`]?.map((el) => {
          message = <>{message}<br /><b>{error}</b>: {el}</>
        })
      })

      await api.error({
        message: 'New user',
        description: message,
        placement: 'topRight'
      })
    } finally {
      refresh()
    }
  }

  const handleCancel = () => {
    setIsModalOpen(false)
  }

  return (
    <>
      {contextHolder}
      <Button type='primary' onClick={showModal}>
        Create user
      </Button>
      <Modal
        title={'Create new user'}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText={'Create'}
      >
        <div>
          <p style={{ paddingBottom: 5, paddingTop: 10 }}>Name</p>
          <Input
            placeholder='Name'
            onChange={(e) => setName(e.target.value)}
            value={name}
          />
        </div>
        <div>
          <p style={{ paddingBottom: 5, paddingTop: 10 }}>First name</p>
          <Input
            placeholder='First name'
            onChange={(e) => setFirstName(e.target.value)}
            value={firstName}
          />
        </div>
        <div>
          <p style={{ paddingBottom: 5, paddingTop: 10 }}>Email</p>
          <Input
            placeholder='Email'
            onChange={(e) => setEmail(e.target.value)}
            value={email}
          />
        </div>
        <div>
          <p style={{ paddingBottom: 5, paddingTop: 10 }}>VAT</p>
          <Input
            placeholder='VAT'
            onChange={(e) => setVat(e.target.value)}
            value={vat}
          />
        </div>
        <div>
          <p style={{ paddingBottom: 5, paddingTop: 10 }}>Phone</p>
          <Input
            placeholder='Phone'
            onChange={(e) => setPhone(e.target.value)}
            value={phone}
          />
        </div>
        <div>
          <p style={{ paddingBottom: 5, paddingTop: 10 }}>Password</p>
          <Input.Password
            placeholder='Password'
            onChange={(e) => setPassword(e.target.value)}
            value={password}
          />
        </div>
        <div>
          <p style={{ paddingBottom: 5, paddingTop: 10 }}>Confirm password</p>
          <Input.Password
            placeholder='Confirm password'
            onChange={(e) => setConfirmPassword(e.target.value)}
            value={confirmPassword}
          />
        </div>
      </Modal>
    </>
  )
}
